import { createApp } from 'vue'
import App from '@/App.vue'
import '@/js/workboxWindow.js'
import unhead from '@/js/unhead.js'
import router from '@/js/router.js'
import store from '@/js/store.js'
import gtag from '@/js/gtag.js'

function hideLoadingScreen() {
	const el = document.getElementById('loading-screen')

	if (!el) return

	el.classList.add('hidden')
	el.addEventListener('transitionend', () => el.remove(), { once: true })
}

async function initApp() {
	const app = createApp(App)

	app.use(unhead)
	app.use(router)
	app.use(store)

	app.mount('#app')

	// Wait for the initial route's lazy chunk to finish loading before dismissing the loading screen.
	await router.isReady()

	function onLoadingComplete() {
		app.use(gtag)
		hideLoadingScreen()
	}

	if (document.readyState === 'complete') {
		onLoadingComplete()
	} else {
		window.addEventListener('load', onLoadingComplete, { once: true })
	}
}

initApp()
